import React from "react"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import CaseStudyTemplate from "../components/case-study-template"
import Footer from "../components/footer"
import { HomeContext } from "../hooks/HomeContext"

const CaseStudiesTemplate = ({ data, pageContext }) => {
  const mod = data.contentfulV4CaseStudiesPages
  const caseStudies = data.contentfulV4OurWorkPage.module1.caseStudies
  const homeData = data.contentfulV4HomePage

  return (
    <HomeContext.Provider value={homeData}>
      <div>
        <CaseStudyTemplate
          mod={mod}
          caseStudies={caseStudies}
          previous={pageContext.previous}
          next={pageContext.next}
        />
        <Footer
          showFooterExtended={mod.showFooterExtended}
          footerExtendedContent={mod.footerExtended}
        />
        <span className="pageClass">{mod.keywords}</span>
      </div>
    </HomeContext.Provider>
  )
}

export default CaseStudiesTemplate

export const Head = ({ data }) => {
  const mod = data.contentfulV4CaseStudiesPages

  return (
    <SEO
      description={mod.metaDescription}
      title={mod.browserPageTitle}
      keywords={mod.keywords}
    />
  )
}

export const query = graphql`
  query($slug: String!) {
    contentfulV4OurWorkPage {
      module1 {
        caseStudies {
          link
          name
        }
      }
    }
    contentfulV4CaseStudiesPages(slug: { eq: $slug }) {
      pageType
      slug
      metadata
      keywords
      browserPageTitle
      backgroundImage {
        gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        id
      }
      backToOurWorkLink
      backToOurWorkText
      navigationArrow {
        gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        id
      }
      leftArrow {
        gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        id
      }
      arrowBullet {
        file {
          url
        }
        id
      }
      caseStudyUrl
      modules {
        ... on ContentfulV4CaseStudyPagesModule1 {
          id
          name
          description {
            description
          }
          internal {
            type
          }
          greetingText
          title
          subTitle
          images {
            title
            description {
              description
            }
            image {
              gatsbyImageData(layout: FULL_WIDTH, quality: 100)
              id
              title
              file {
                url
                fileName
                details {
                  size
                  image {
                    height
                    width
                  }
                }
              }
            }
          }
        }
        ... on ContentfulV4CaseStudyPagesQuoteModule {
          id
          name
          internal {
            type
          }
          quote {
            quote
          }
          author
          position
        }
        ... on ContentfulV4CaseStudyPagesModule2 {
          id
          name
          bulletPoints {
            bullets
          }
          title
          internal {
            type
          }
          description {
            description
          }

          images {
            image {
              gatsbyImageData(layout: FULL_WIDTH, quality: 100)
              id
              title
              file {
                url
                fileName
                details {
                  size
                  image {
                    height
                    width
                  }
                }
              }
            }
            description {
              description
            }
            title
          }
        }
      }
      previousAndNextCaseStudy {
        previous {
          title
          link
          caseStudy
        }
        next {
          link
          title
          caseStudy
        }
        id
      }
      footerExtended {
        content {
          id
          link
          linkText
          title
          description
          icon {
            gatsbyImageData(layout: FULL_WIDTH, quality: 100)
            id
          }
          arrow {
            gatsbyImageData(layout: FULL_WIDTH, quality: 100)
            id
          }
        }
      }
      showFooterExtended
    }
    contentfulV4HomePage(slug: { eq: "/" }) {
      readyForEndToEnd {
        title
        leftButton {
          text
          to
        }
        rightButton {
          text
          to
        }
      }
    }
  }
`
